import { Component, OnInit } from '@angular/core';
import { COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION, COGNITO_ERROR_CODE_MISMATCH_EXCEPTION, COGNITO_ERROR_EXPIRED_CODE_EXCEPTION } from 'src/app/utils/constant';
import { PasswordValidator } from 'src/app/utils/password-validator';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AuthService, DialogService, LanguageService } from 'src/app/services';
import { ActivatedRoute, Router } from '@angular/router';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { LoginService } from '../login/login.service';
import { catchError } from 'rxjs/operators';
import * as _ from 'lodash';
import { of } from 'rxjs';

@Component({
  selector: 'esc-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  show: any = {
    confirm: false,
    password: false
  }
  resetPasswordForm : FormGroup;
  isResendingCode: boolean;
  isSubmitting : boolean;
  errorMessage : string;

  constructor(
    private router: Router,
    private fb: FormBuilder, 
    private route: ActivatedRoute, 
    public authService: AuthService,
    private loginService: LoginService,
    private dialogService: DialogService,
    public languageService: LanguageService,
  ){ }

  ngOnInit() {
    this.resetPasswordForm = this.fb.group({
      username: [null, Validators.required],
      code: [null, Validators.required],
      password: [null, Validators.compose([Validators.required, Validators.minLength(8), Validators.maxLength(60), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\^$*.\[\]{}()?\-\"!@#%&/\\,><':;|_~`])[A-Za-z\d\^$*.\[\]{}()?\-\"!@#%&/\\,><':;|_~`]{0,}/)])],
      confirmPassword: [null, Validators.required]
    }, {
      validator: PasswordValidator.matchPassword
    });
    this.route.queryParams.subscribe(params => {
      if(params['username']){
        this.resetPasswordForm.controls['username'].setValue(_.toUpper(params['username']));
      }
      if(params['code']){
        this.resetPasswordForm.controls['code'].setValue(_.toUpper(params['code']));
      }
    });
  }

  resendVerificationCode(value){
    this.isResendingCode = true;
    this.errorMessage = null;
    let username = _.trim(value['username']);

    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.authService.userPool
    });

    cognitoUser.forgotPassword({
      onSuccess: (data) => {
        this.isResendingCode = false;
        this.resetPasswordForm.controls['code'].reset();
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_VERIFICATION_RESENT", {}))
        this.router.navigate([], { 
          queryParams: {
            username: username
          } 
        });
      },
      onFailure: (err) => {
        this.isResendingCode = false;
        console.log(err);
        if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
          return this.resetPasswordForm.controls['username'].setErrors({
            "notExisting": true
          });
        }
        this.errorMessage = err.message;
      }
    });
  }

  onSubmit(value: any){
    this.errorMessage = null;
    this.isSubmitting = true;
    let username = _.trim(value['username']);
    let newPassword = _.trim(value['password']);
    let code = _.trim(value['code']);

    let cognitoUser = new CognitoUser({
      Username: username,
      Pool: this.authService.userPool
    });

    cognitoUser.confirmPassword(code, newPassword,{
      onSuccess: () => {
        this.isSubmitting = false;
        this.dialogService.openSnackBar(this.languageService.getTranslation("MSG_LOGIN_NEW_PASSWORD", {}))
          .afterOpened()
          .subscribe(() => {
            // this.loginService.updateLastChangePasswordDate({ userName: username }).pipe(
            //   catchError((err) => {
            //     console.error(err);
            //     return of(null);
            //   })
            // ).subscribe((res) => {
            //   // console.log(res);
            // });
            this.router.navigate(["/login"]);
        })
      },
      onFailure: (err) => {
        this.isSubmitting = false;
        console.log(err);
        if(err.name === COGNITO_ERROR_USER_NOT_FOUND_EXCEPTION){
          this.resetPasswordForm.controls['username'].setErrors({
            "notExisting": true
          });
        } else if(err.name === COGNITO_ERROR_CODE_MISMATCH_EXCEPTION || err.name === COGNITO_ERROR_EXPIRED_CODE_EXCEPTION){
          this.resetPasswordForm.controls['code'].setErrors({
            "codeMismatch": true
          });
          this.router.navigate([], { 
            queryParams: {
              username: username
            } 
          });
        } else {
          this.errorMessage = err.message;
        } 
        
        if (err.name === 'PasswordHistoryPolicyViolationException'){
          this.resetPasswordForm.controls['password'].setErrors({
            "reusedPassword": true
          });
          this.errorMessage = null;
        }
      }
    });
  }

}
